<div class="first-row">
</div>
<div class="second-row">
    <div class="icon">
        <fa-layers [fixedWidth]="true">
            <fa-icon [icon]="faSquare" size="2x" [styles]="{'color': '#000000'}" transform="shrink-6 right-2 down-2">
            </fa-icon>
            <fa-icon [icon]="faWarring" size="2x"
                [styles]="{'stroke': '#000', 'stroke-width': '10', 'color': '#ffc400'}">
            </fa-icon>
        </fa-layers>
    </div>
    {{'auth.forbidden' | translate}}
</div>
<div class="third-row">
</div>